import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';
export const LoganNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="logan" />;
};
